class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Header');
    
    if (!this.container) {
      console.log('Barre de recherche header non trouvée');
      return;
    }
    
    this.form = this.container.querySelector('form');
    this.input = this.container.querySelector('#header-search-input');
    this.resultsContainer = this.container.querySelector('.header-search-results');
    this.predictiveSearchDiv = this.resultsContainer?.querySelector('.thb-predictive-search');

    if (!this.form || !this.input) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', () => {
      if (this.getQuery().length > 0) {
        this.resultsContainer?.classList.add('active');
      }
    });

    // Fermer avec clic extérieur
    document.addEventListener('click', (event) => {
      if (!this.container.contains(event.target)) {
        this.close();
      }
    });

    // Fermer avec Escape
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  close() {
    this.resultsContainer?.classList.remove('active');
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close();
      return;
    }
    
    this.resultsContainer?.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  getSearchResults(searchTerm) {
    if (!this.resultsContainer || !this.predictiveSearchDiv) return;
    
    this.resultsContainer.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product,article,query&resources[limit]=10&section_id=predictive-search`)
      .then((response) => {
        this.resultsContainer.classList.remove('loading');
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        console.error('Erreur:', error);
        this.resultsContainer.classList.remove('loading');
      });
  }

  renderSearchResults(resultsMarkup) {
    if (!this.predictiveSearchDiv) return;
    
    this.predictiveSearchDiv.innerHTML = resultsMarkup;
    
    const submitButton = this.resultsContainer.querySelector('#search-results-submit');
    if (submitButton) {
      submitButton.addEventListener('click', () => {
        this.form.submit();
      });
    }
  }
}

window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});